const appraiser = {
  appraiserList(text) {
    if (text) {
      return `/appraiser/all?searchTerm=${text}`;
    }
    return `/appraiser/all`;
  },

  getAppraiserProfile(id) {
    return `/appraiser/${id}`;
  },

  getAppraiserManagers() {
    return `/appraiser/managers`;
  },

  getValuationDirectors() {
    return `/employees/by-role?roles=VALUATION_QUALITY_MANAGER`;
  },

  getCertificateList() {
    return `/appraiser/certificate`;
  },

  getDesignationList() {
    return `/appraiser/designation`;
  },

  getStateList() {
    return `/regions/states`;
  },

  getLicenseImage() {
    return "/appraiserlicenses";
  },

  getAllLicenses(id) {
    return `/appraiserlicenses/${id}`;
  },

  deleteAppraiserLicense(id) {
    return `/appraiserlicenses/${id}`;
  },

  deleteAppraiserLicenseImage(id) {
    return `/appraiserlicenses/${id}/image`;
  },

  updateAppraiserLicense() {
    return "/appraiserlicenses";
  },

  addAppraiserLicense() {
    return "/appraiserlicenses";
  },

  addAppraiserSignature(id) {
    return `/appraiser/${id}/signature`;
  },

  deleteAppraiserSignature(id) {
    return `/appraiser/${id}/signature`;
  },

  getAppraiserSignatureExists(id) {
    return `/appraiser/${id}/signature/exists`;
  },

  updateAppraiserProfile(id) {
    return `/appraiser/${id}`;
  },

  getPaySummary(appraiserNumber, payPeriodId) {
    return `/appraiser/${appraiserNumber}/paySummary/${payPeriodId}`;
  },

  getAppraiserListByAppraisalId(appraisalId) {
    return `/appraiser/appraisals/${appraisalId}`;
  },

  getMinimalAppraiserList() {
    return `/appraiser/minimal-list`;
  },
};

export default appraiser;
